import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-vertical-tab-option',
  templateUrl: './vertical-tab-option.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerticalTabOptionComponent {
  @HostBinding('class')
  private readonly classes = 'block px-3 relative group cursor-pointer';

  @Input()
  selectedClasses = 'bg-navy-40';

  @Input()
  selected: boolean;

  @Input()
  selectHighlight? = true;

  @Input()
  disabled: boolean;

  getDynamicClasses(): Record<string, boolean> {
    return {
      [this.selectedClasses]: this.selected,
      'pointer-events-none text-navy-50': this.disabled,
      'text-navy-90 group-hover:bg-navy-40': !this.disabled,
    };
  }
}
